import { get } from 'vuex-pathify';
export default {
  computed: {
    komadresSelectedDataSource: get('admin/modulesMapping@komadres_orders.komadres_orders_datasource'),
    isKomadresSettingsEnabled: get('admin/settingsValues@komadres_orders_module_enabled'),
    isKomadresModuleEnabled: get('admin/additionalModules@KOMADRES_ORDERS.enabled'),
    hasKomadresPermissions() {
      return this.$store.get('users/toolsPermissions')['KOMADRES_ORDERS'].main_value > 0;
    },
    isKomadresOrderVisible() {
      return (
        this.isKomadresSettingsEnabled &&
        this.isKomadresModuleEnabled &&
        this.hasKomadresPermissions &&
        this.hasGeometry &&
        this.currentLayerDataSourceName !== this.komadresSelectedDataSource
      );
    },
    komadresButton() {
      return this.isKomadresOrderVisible
        ? [
            {
              name: 'createKomadres',
              icon: '$createKomadresOrder',
              color: 'font',
              tooltip: this.isAnyFeatureSelected
                ? this.$i18n.t('button.addKomadresOrder')
                : this.$i18n.t('button.toCreateKomadresOrder', {
                    suffix: this.$i18n.t('button.atLeastOneSelected'),
                  }),
              fontSize: '19px',
              disabled: !this.isAnyFeatureSelected,
            },
          ]
        : [];
    },
  },
  data: () => ({
    isKomadresDialogVisible: false,
    isKomadresDialogLoaded: false,
  }),
  methods: {
    createKomadresAction() {
      this.isKomadresDialogLoaded = true;
      this.isKomadresDialogVisible = true;
    },
  },
};
